import React from "react";
import {
    GridSelectorProps,
    GridSelector,
} from "../GridSelector";

export type LeagueSelectorProps = Omit<GridSelectorProps<string | number>, "idPrefix">;

export default function LeagueSelector(props: LeagueSelectorProps) {
    return (
        <GridSelector
            {...props}
            idPrefix="league-selector"
        />
    );
}
